import React, { useState } from "react";
import './css/IPOSummary.css'
import './css/Confirmation.css'
import SummaryTable from "./SummaryTable";
import errorImg from "../../assets/iposub/cancelledstick.svg"
import successImg from "../../assets/iposub/successtick.svg"
import { useNavigate } from "react-router-dom";

const Confirmation = ({
    nextStep,
    prevStep,
    ipoDetails,
    status,
    summaryData
}) => {
    console.log(ipoDetails)

    const stepBack = () => {
        prevStep();
    }

    const navigate = useNavigate();
    const goToDashboard = () =>{
        navigate("/home/dashboard");
    }
    const appl_no = ipoDetails.Indetails?.BidingDetails?.appl_no || ipoDetails.Indetails?.appl_no

    return (
        <div>
            <div className="col-lg-12 col-md-12 col-12 addmargin">
                <h5 className='transactionheader'>IPO CONFIRMATION</h5>
                <p className="transactionheader_desc">Retail investors are individual investors who can share purchase applications of up to ₹2 lakh</p>

            </div>

            <div className="IPOCard-List">
                <div className="row makerel">
                    {
                        status == 'success' && 
                        <div className="successdiv">
                        <img src={successImg} alt='succimg' className="succImg" />
                        <div>
                            <p>
                                Your Application {!!appl_no&&`#${appl_no}`} was submitted through KFintech successfully!
                            </p>
                            <p>
                                You will receive a confirmation on application approval or disapproval from NSDL.
                            </p>
                        </div>
                    </div>
                    }
                    

                    {
                        status == 'cancel' && 
                        <div className="errordiv">
                        <img src={errorImg} alt='succimg' className="succImg" />
                        <p>Order cancelled</p>
                    </div>
                    }

               


                    <SummaryTable nextStep={nextStep} prevStep={prevStep} 
                    ipoDetail={ipoDetails}
                      summaryData={summaryData} />

                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-12 text-center">
            <button className="GoTodashboardBTN" onClick={() => goToDashboard()}>GO TO DASHBOARD</button>

            </div>
        </div>
    );
}

export default Confirmation;